import avatar from '../assets/avatar-image.jpg';

// utils/guestUser.js
export const GUEST_USER = {
  _id: 'guest-user-id',
  _type: 'user',
  userName: 'Guest User',
  image: avatar,
  googleId: 'guest-google-id',
  // Add any other fields your app requires for users
};
